import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Login from "@/components/LoginComponent/Login.vue";
import Home from "@/components/HomeComponent/HomePage.vue";
import HomeContent from "@/components/HomeComponent/HomeContent.vue";
import RegisterForm from "@/components/registration/RegisterForm.vue";
import Applications from "@/components/modules/studentApplications/Applications.vue";
import AddEditApplication from "@/components/modules/studentApplications/AddEditApplication.vue";
import ViewApplicationDetails from "@/components/modules/studentApplications/ViewApplicationDetails.vue";
import ListApplications from "@/components/modules/studentApplications/ListApplications.vue";
import ReorderApplications from "@/components/modules/studentApplications/ReorderApplications.vue";
import PrintApplication from "@/components/modules/studentApplications/PrintApplication";
import ProfileIndex from "@/components/modules/userProfile/Index.vue";
import ViewProfile from "@/components/modules/userProfile/View.vue";
import EditProfile from "@/components/modules/userProfile/Edit.vue";
import Notifications from "@/components/HomeComponent/Notifications.vue";
import NominationCard from "@/components/modules/studentApplications/NominationCard.vue";

Vue.use(VueRouter);
const loginGuard = (to, from, next) => {
  if (store.getters.getToken) {
    next({ path: "/home" });
    return;
  }
  next();
};
const homeGuard = (to, from, next) => {
  if (!store.getters.getToken) {
    next({ path: "/login" });
    return;
  }
  next();
};

const routes = [
  {
    path: "",
    redirect: "/home"
  },
  {
    path: "/home",
    component: Home,
    beforeEnter: homeGuard,
    children: [
      {
        path: "/",
        name: "Content",
        component: HomeContent
      },
      {
         path:"/notifications",
         name:"notifications",
         component:Notifications
      },
      {
        path: "ApplicationData",
        component: Applications,
        children: [
          {
            path: "AddApplication",
            name: "AddApplication",
            component: AddEditApplication
          },
          {
            path: "EditApplication/:id?",
            name: "EditApplication",
            component: AddEditApplication
          },
          {
            path: "ListApplications",
            name: "ListApplications",
            component: ListApplications
          },
          {
            path: "ReorderApplications",
            name: "ReorderApplications",
            component: ReorderApplications
            
          },
          {
            path: "ViewApplication/:id?",
            name: "ViewApplication",
            component: ViewApplicationDetails
          },
          {
            path: "ViewApplication/Print/:id?",
            name: "PrintApplication",
            component: PrintApplication
          },
          {
          path: '/NominationCard/:appID',
          name: 'NominationCard',
          component: NominationCard
        }
        ]
      },
      {
        path: "Profile",
        component: ProfileIndex,
        children: [
          {
            path: "",
            name: "ViewProfile",
            component: ViewProfile
          },
          {
            path: "Edit",
            name: "EditProfile",
            component: EditProfile
          }
        ]
      }
    ]
  },
  {
    path: "/login",
    component: Login,
    beforeEnter: loginGuard
  },
  {
    path: "*",
    redirect: "/"
  },
  {
    path: "/register",
    name: "register",
    component: RegisterForm
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
